import { LANGUAGE } from "@/common/utils/constants.js";

export const GOP_COMPONENTS = {
	[LANGUAGE.en.short]: {
		edit: 'Edit',
		delete: 'Delete',
		openAttachment: 'Open Attachment',
		manageCustomizedFilters: 'Manage customized filters',
		questionsOrAssistance: 'Questions or need assistance?',
		contactUs: 'Contact us by email',
		cancel: 'Cancel',
		create: 'Create',
		name: 'Name',
		characters: '/50 characters',
		filter: 'Filter',
		select: 'Select',
		deselect: 'Deselect all',
		createCustomizedFilter: '+ Create customized filter',
		filterSetPlaceholder: 'Write the filter set name here',
		update: 'Update',
		deleteFilter: 'Delete filter set',
		applySearch: 'Apply to search'
	},
	[LANGUAGE.de.short]: {
		edit: 'Bearbeiten',
		delete: 'Löschen',
		openAttachment: 'Anhang öffnen',
		manageCustomizedFilters: 'Benutzerdefinierte Filter verwalten',
		questionsOrAssistance: 'Fragen oder Hilfe benötigt?',
		contactUs: 'Kontaktieren Sie uns per E-Mail',
		cancel: 'Abbrechen',
		create: 'Erstellen',
		name: 'Name',
		characters: '/50 Zeichen',
		filter: 'Filtern',
		select: 'Auswählen',
		deselect: 'Alle abwählen',
		createCustomizedFilter: '+ Benutzerdefinierten Filter erstellen',
		filterSetPlaceholder: 'Namen des Filtersatzes hier eingeben',
		update: 'Aktualisieren',
		deleteFilter: 'Filtersatz löschen',
		applySearch: 'Auf Suche anwenden'
	},
	[LANGUAGE.fr.short]: {
		edit: 'Modifier',
		delete: 'Supprimer',
		openAttachment: 'Ouvrir la pièce jointe',
		manageCustomizedFilters: 'Gérer les filtres personnalisés',
		questionsOrAssistance: 'Des questions ou besoin d\'aide?',
		contactUs: 'Contactez-nous par e-mail',
		cancel: 'Annuler',
		create: 'Créer',
		name: 'Nom',
		characters: '/50 caractères',
		filter: 'Filtrer',
		select: 'Sélectionner',
		deselect: 'Tout désélectionner',
		createCustomizedFilter: '+ Créer un filtre personnalisé',
		filterSetPlaceholder: 'Saisissez le nom du jeu de filtres ici',
		update: 'Mettre à jour',
		deleteFilter: 'Supprimer le jeu de filtres',
		applySearch: 'Appliquer à la recherche'
	},
	[LANGUAGE.it.short]: {
		edit: 'Modifica',
		delete: 'Elimina',
		openAttachment: 'Apri allegato',
		manageCustomizedFilters: 'Gestisci i filtri personalizzati',
		questionsOrAssistance: 'Domande o assistenza?',
		contactUs: 'Contattaci via e-mai',
		cancel: 'Annulla',
		create: 'Crea',
		name: 'Nome',
		characters: '/50 caratteri',
		filter: 'Filtra',
		select: 'Seleziona',
		deselect: 'Deseleziona tutto',
		createCustomizedFilter: '+ Crea filtro personalizzato',
		filterSetPlaceholder: 'Inserisci qui il nome del set di filtri',
		update: 'Aggiorna',
		deleteFilter: 'Elimina set di filtri',
		applySearch: 'Applica alla ricerca'
	},
	[LANGUAGE.ja.short]: {
		edit: '編集',
		delete: '削除',
		openAttachment: '添付ファイルを開く',
		manageCustomizedFilters: 'カスタムフィルターの管理',
		questionsOrAssistance: 'ご質問・お困りですか？',
		contactUs: 'メールでお問い合わせ',
		cancel: 'キャンセル',
		create: '作成',
		name: '名前',
		characters: '/50文字',
		filter: 'フィルター',
		select: '選択',
		deselect: 'すべて選択解除',
		createCustomizedFilter: '+ カスタムフィルターを作成',
		filterSetPlaceholder: 'フィルターセット名をここに入力してください',
		update: '更新',
		deleteFilter: 'フィルターセットを削除',
		applySearch: '検索に適用'
	},
	[LANGUAGE.es.short]: {
		edit: 'Editar',
		delete: 'Eliminar',
		openAttachment: 'Abrir archivo adjunto',
		manageCustomizedFilters: 'Gestionar filtros personalizados',
		questionsOrAssistance: 'Preguntas o necesita ayuda?',
		contactUs: 'Contáctenos por email',
		cancel: 'Cancelar',
		create: 'Crear',
		name: 'Nombre',
		characters: '/50 caracteres',
		filter: 'Filtrar',
		select: 'Seleccionar',
		deselect: 'Desmarcar todo',
		createCustomizedFilter: '+ Crear filtro personalizado',
		filterSetPlaceholder: 'Escriba aquí el nombre del conjunto de filtros',
		update: 'Actualizar',
		deleteFilter: 'Eliminar conjunto de filtros',
		applySearch: 'Aplicar a la búsqueda'
	}
}
